import { AuthPage } from './AuthPage';

export const Login = () => <AuthPage mode="login" />;
